export const Colors = {
    // PRIMARY
    'green-deloitte': '#86BC25',
    'green-4': '#43B02A',
    'green-aa': '#26890D',
    'black-1': '#000000',
    'teal-aa': '#0D8390',
    'blue-aa': '#007CB0',
    // SECONDARY
    'green-7': '#2C5234',
    'green-5': '#009A44',
    'green-2': '#C4D600',
    'green-1': '#E3E48D',
    'blue-7': '#041E42',
    'blue-6': '#012169',
    'blue-5': '#005587',
    'blue-4': '#0076A8',
    'blue-3': '#00A3E0',
    'blue-2': '#62B5E5',
    'blue-1': '#A0DCFF',
    'teal-7': '#004F59',
    'teal-6': '#007680',
    'teal-5': '#0097A9',
    'teal-4': '#00ABAB',
    'teal-3': '#6FC2B4',
    'teal-2': '#9DD4CF',
    'teal-1': '#DDEFE8',
    'coolgray-12': '#222222',
    'coolgray-11': '#53565A',
    'coolgray-10': '#63666A',
    'coolgray-9': '#75787B',
    'coolgray-7': '#97999B',
    'coolgray-6': '#A7A8AA',
    'coolgray-4': '#BBBCBC',
    'coolgray-2': '#D0D0CE',
    // BRIGHT
    'brightgreen': '#0DF200',
    'brightteal': '#3EFAC5',
    'brightblue': '#33F0FF',
    // NEUTRAL
    'neutral3': '#DCE3E5',
    'neutral2': '#E6EDF0',
    'neutral1': '#F2F6F7',
    'neutral0.5': '#F5F8FA',
    'white': '#FFFFFF',
    // SEMANTIC
    'information-6': '#174291',
    'information-5': '#1D53B7',
    'information-4': '#276EF1',
    'information-3': '#5A90F4',
    'information-2': '#9FBFF8',
    'information-1': '#D4E2FC',
    'success-6': '#156A36',
    'success-5': '#09863D',
    'success-4': '#21A453',
    'success-3': '#43BF75',
    'success-2': '#9EE2B8',
    'success-1': '#CFF3DD',
    'error-6': '#7F281E',
    'error-5': '#A13226',
    'error-4': '#D44333',
    'error-3': '#DE7063',
    'error-2': '#ECACA5',
    'error-1': '#F6D9D6',
    'warning-6': '#916821',
    'warning-5': '#C19132',
    'warning-4': '#FFC043',
    'warning-3': '#FFCF70',
    'warning-2': '#FFE3AC',
    'warning-1': '#FFF2D9',

    //PRIORITY
    'critical-dark': '#540000',
    'critical-base': '#E82020',
    'critical-light': '#FECECE',
    'high-dark': '#4D1A00',
    'high-base': '#EE722E',
    'high-light': '#FFE2D1',
    'medium-dark': '#4D4D00',
    'medium-base': '#FADA33',
    'medium-light': '#FFF6A5',
    'low-dark': '#004D10',
    'low-base': '#5BDA77',
    'low-light': 'rgba(202, 248, 212, 1)',
};
